module.exports = __webpack_public_path__ + "img/pijltje-klein-rechts.167414bd320400d21c617ca75b2640f3.svg";